<!-- biome-ignore-all lint/a11y/useValidAnchor: <angular> -->
<header class="border-outlineVariant bg-surface sticky top-0 z-20 flex h-[60px] w-full items-center border-b px-4! shadow-sm">
  <div class="flex w-full items-center justify-between gap-[30px]">
    <div class="flex items-center">
      <div class="title flex items-center">
        <h6 class="text-onSurfaceVariant">{{ fullTitle() }}</h6>
      </div>
    </div>
    <div class="text-subtitle-1 flex items-center gap-7">
      @if (dropdowns().length > 0) {
      <div class="flex items-center gap-3">
        @if (headerReadonlyLabel()) {
        <span class="text-label-medium text-lowEmphasis whitespace-nowrap border border-outlineVariant rounded px-2 py-1.5">{{ headerReadonlyLabel() }}</span>
        } @for (dropdown of dropdowns(); track $index) {
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="order-sort-select w-44">
          @if (dropdown.label) {
          <mat-label>{{ dropdown.label }}</mat-label>
          }
          <mat-select
            [id]="'headerDropdown-' + $index"
            [disabled]="dropdown.enabled === false"
            panelClass="order-sort-select-panel"
            [value]="dropdown.selected"
            (selectionChange)="dropdown.onChange($event.value)"
          >
            @for (opt of dropdown.options; track opt.value) {
            <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        }
      </div>
      }
      <ul class="flex items-center gap-4">
        @for (item of header_links(); track $index) {
        <li>
          <a
            [matTooltip]="item.tooltip"
            [matTooltipPositionAtOrigin]="true"
            [matTooltipPosition]="'below'"
            class="hover:bg-hoverOverlay focus:bg-focusOverlay active:bg-focusOverlay h-fit"
            [routerLink]="item.routerLink"
            (click)="item?.callback()"
            mat-icon-button
          >
            <mat-icon class="text-onSurfaceVariant">{{ item.icon }}</mat-icon>
          </a>
        </li>
        }
      </ul>
      <div class="hidden items-center md:flex">
        <div
          class="bg-onSurfaceVariant flex h-8 w-8 grow-0 items-center justify-center rounded-full font-normal text-white"
          [ngStyle]="{
            'background-size': 'contain',
            'background-image': 'url(' + (profilePicture$ | async) + ')'
          }"
        >
          @if ((profilePicture$ | async) === null) {
          <span>{{ initalizes$ | async }}</span>
          }
        </div>
      </div>
      <div class="header-logo"></div>
    </div>
  </div>
</header>
